import { render, staticRenderFns } from "./consulting.vue?vue&type=template&id=351d3bf2"
import script from "./consulting.vue?vue&type=script&lang=js"
export * from "./consulting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports